import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useLogin } from '@/lib/api/orval/target/auth/auth';
import { getAuthStore } from '@/stores/authStore';
import { errorMessage } from '@/lib/errors';

export function Login(): React.ReactElement {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const login = useLogin({
    mutation: {
      onSuccess: (user) => {
        getAuthStore().getState().setUser(user);
        navigate('/machines/mine');
      },
    },
  });

  return (
    <div className="max-w-sm mx-auto themed-card p-6 flex flex-col gap-4">
      <h1 className="text-2xl font-semibold">Log in</h1>
      <form
        className="flex flex-col gap-3"
        onSubmit={(e) => {
          e.preventDefault();
          login.mutate({ data: { email, password } });
        }}
      >
        <input
          className="themed-input"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          className="themed-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button className="btn-primary" type="submit" disabled={login.isPending}>
          {login.isPending ? 'Logging in…' : 'Log in'}
        </button>
      </form>
      {login.isError && (
        <p style={{ color: 'var(--danger)' }}>{errorMessage(login.error)}</p>
      )}
      <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
        No account? <Link to="/register">Sign up</Link>
      </p>
    </div>
  );
}
